import { CreationTime } from "@/components/CreationTime";
import type { PlainPrompt } from "@/queries/prompt-queries";
import type { FC } from "react";

export const SkillCreatedAt: FC<{ skill: PlainPrompt }> = ({ skill }) => {
    return (
        <div className="text-xs text-content-secondary">
            Created <CreationTime timestamp={skill.metadata?.createdAt} />
        </div>
    );
};
